export default "__VITE_ASSET__Dbm2mXtl__"